var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.37998 25.3364C0.37998 26.0452 0.95412 26.62 1.66362 26.62C2.37311 26.62 2.94725 26.0452 2.94725 25.3364C2.94725 21.2176 5.30741 17.5691 8.99222 15.8272C10.2951 16.6618 11.8398 17.1509 13.4988 17.1509C15.164 17.1509 16.7146 16.6585 18.0206 15.8182C19.1107 16.3393 20.1198 17.0351 20.9611 17.8759C22.9548 19.8701 24.0527 22.5194 24.0527 25.3364C24.0527 26.0452 24.6269 26.62 25.3363 26.62C26.0458 26.62 26.62 26.0452 26.62 25.3364C26.62 21.8341 25.2547 18.5398 22.7763 16.0607C21.9736 15.2576 21.0458 14.5659 20.0513 13.9913C21.1975 12.5571 21.8843 10.7401 21.8843 8.76547C21.8843 4.14156 18.1221 0.380011 13.4988 0.380011C8.8755 0.380011 5.11337 4.14156 5.11337 8.76547C5.11337 10.7352 5.79722 12.5476 6.93821 13.9801C2.90361 16.2992 0.37998 20.5747 0.37998 25.3364ZM13.4988 2.94728C16.7067 2.94728 19.317 5.5576 19.317 8.76547C19.317 11.9733 16.7067 14.5836 13.4988 14.5836C10.291 14.5836 7.68064 11.9733 7.68064 8.76547C7.68064 5.5576 10.291 2.94728 13.4988 2.94728Z",
    fill: "#353B7D",
    stroke: "#353B7D",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavUser);
export default __webpack_public_path__ + "static/media/nav-user.844e7171a5c5f9db8e2d4bf1ec15a1ea.svg";
export { ForwardRef as ReactComponent };